/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'


const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

const Checkbox = (props) => {
  const {
    id,
    parentId,
    className,
    parentClassName,
    name,
    value,
    checked = false,
    inverse,
    children,
    disabled,
    onChange = () => {},
    parentProps,
    hasError = false,
    errorMessage = 'Por favor, preencha este campo corretamente.',
    ...rest
  } = props


  const [isCheck, setIsCheck] = React.useState(checked)
  const _input = React.useRef(null)

  const [error] = React.useState({
    message: errorMessage, // erroMessage
    hasError: hasError
  })

  React.useEffect(() => {
    setIsCheck(checked)
    _input.current.checked = checked
  }, [checked])

  const handleChange = (e) => {
    const status = !isCheck
    _input.current.checked = status

    setIsCheck(status)
    !!onChange && onChange(status)
  }

  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleChange(e)
    }
  }

  return (
    <div
      tabIndex={0}
      aria-label="checkbox"
      onKeyPress={(e) => handleKeyPress(e)}
      className={`${resolveProps(props, config, 'Checkbox')} ${
        parentClassName || ''
      }
        ${error.hasError ? 'mdn-Checkbox--attentionField' : ''}`}
      {...parentProps}
    >
      <input
        className="mdn-Checkbox-input"
        id={id}
        type="checkbox"
        ref={_input}
        onChange={(e) => handleChange(e)}
        disabled={disabled}
        {...rest}
      />
      <label className="mdn-Checkbox-label" htmlFor={id}></label>
      <label
        className="mdn-Checkbox-text"
        htmlFor={id}
      >
        {children}
      </label>

      {!error.hasError ? (
        ''
      ) : (
        <small className="mdn-Input-errorFeedback">{error.message}</small>
      )}
    </div>
  )
}

export default Checkbox

Checkbox.propTypes = {
  id: PropTypes.string,
  parentId: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  inverse: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  config: PropTypes.object,
  hasError: PropTypes.bool,
  parentProps: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
    hasError: PropTypes.bool
  })
}
